<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M11.8571 2.00391C12.4094 2.00391 12.8571 2.45162 12.8571 3.00391L12.8571 6.50391C12.8571 8.71304 11.0663 10.5039 8.85714 10.5039L5.53702 10.5039L7.43232 12.2729C7.83607 12.6497 7.85789 13.2825 7.48106 13.6862C7.10422 14.09 6.47143 14.1118 6.06768 13.735L2.31768 10.235C2.11505 10.0458 2 9.78109 2 9.50391C2 9.22672 2.11505 8.96198 2.31768 8.77285L6.06768 5.27285C6.47143 4.89602 7.10422 4.91784 7.48106 5.32159C7.85789 5.72534 7.83607 6.35813 7.43232 6.73496L5.53702 8.50391L8.85714 8.50391C9.96171 8.50391 10.8571 7.60848 10.8571 6.50391L10.8571 3.00391C10.8571 2.45162 11.3049 2.00391 11.8571 2.00391Z"
    fill="currentColor"
  />
</template>
